import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AccesilityService } from '../../services/accesibility.service';
import { MatDialog } from '@angular/material/dialog';
import { SitemapComponent } from './components/sitemap/sitemap.component';

@Component({
    selector: 'app-accessibility',
    templateUrl: './accessibility.component.html',
    styleUrls: ['./accessibility.component.scss'],
})
export class AccessibilityComponent implements OnInit {
    //Persistencia de las opciones de accesibilidad seleccionadas
    perfilSeleccionado: string | null = null;
    funcionesActivas: { [clave: string]: boolean } = {};

    /**
     * Indica si el modal de accesibilidad está visible.
     */
    public showModal: boolean = false;
    constructor(
        private a11y: AccesilityService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        const savedConfig = JSON.parse(localStorage.getItem('a11y-user-config') || '{}');

        this.funcionesActivas = {
            fuenteGrande: savedConfig.tamanoFuente > 1,
            fuentePequena: savedConfig.tamanoFuente < 1,
            espaciado: savedConfig.espaciado > 0,
            resaltarEnlaces: savedConfig.resaltoEnlaces || false,
            contraste1: savedConfig.altoContraste || false,
            ocultarImagenes: savedConfig.ocultarImagenes || false,
            pausarAnimaciones: savedConfig.pausarAnimaciones || false,
            dislexia: savedConfig.dislexia || false,
            cursorGrande: savedConfig.granCursor || false,
            mascaraLectura: savedConfig.mascaraLectura || false,
            guiaLectura: savedConfig.guiaLectura || false,
            lenguajeSenas: savedConfig.lenguajeSenas || false,
        };
    }

    irCentroRelevo() {
        this.a11y.openCentroDeRelevo();
    }

    activarFuenteDislexia() {
        this.a11y.toggleDyslexiaFont();
        this.funcionesActivas['dislexia'] = !this.funcionesActivas['dislexia'];
    }

    aumentarTamanoFuente() {
        this.a11y.incrementFontSize();
        const config = JSON.parse(localStorage.getItem('a11y-user-config') || '{}');

        this.funcionesActivas['fuenteGrande'] = config.tamanoFuente > 1;
        this.funcionesActivas['fuentePequena'] = config.tamanoFuente < 1;
    }

    disminuirTamanoFuente() {
        this.a11y.decrementFontSize();
        const config = JSON.parse(localStorage.getItem('a11y-user-config') || '{}');

        this.funcionesActivas['fuenteGrande'] = config.tamanoFuente > 1;
        this.funcionesActivas['fuentePequena'] = config.tamanoFuente < 1;
    }

    cambiarEspaciado() {
        this.a11y.toggleSpacing();
        this.funcionesActivas['espaciado'] = !this.funcionesActivas['espaciado'];
    }

    resaltarEnlaces() {
        this.a11y.toggleLinks();
        this.funcionesActivas['resaltarEnlaces'] = !this.funcionesActivas['resaltarEnlaces'];
    }

    ocultarImagenes() {
        this.a11y.toggleImages();
        this.funcionesActivas['ocultarImagenes'] = !this.funcionesActivas['ocultarImagenes'];
    }

    detenerAnimaciones() {
        this.a11y.toggleAnimations();
        this.funcionesActivas['pausarAnimaciones'] = !this.funcionesActivas['pausarAnimaciones'];
    }

    cambiarContraste() {
        this.a11y.toggleContrast();
        this.funcionesActivas['contraste1'] = !this.funcionesActivas['contraste1'];
    }

    grancursor() {
        this.a11y.toggleLargeCursor();
        this.funcionesActivas['granCursor'] = !this.funcionesActivas['granCursor'];
    }

    activarMascaraLectura() {
        this.a11y.toggleReadingMask();
        this.funcionesActivas['mascaraLectura'] = !this.funcionesActivas['mascaraLectura'];
    }

    activarGuiaLectura() {
        this.a11y.toggleReadingGuide();
        this.funcionesActivas['guiaLectura'] = !this.funcionesActivas['guiaLectura'];
    }

    changeState() {
        this.showModal = !this.showModal;
    }

    activarLenguajeSenas() {
        this.a11y.toggleSignLanguage();
        this.funcionesActivas['lenguajeSenas'] = !this.funcionesActivas['lenguajeSenas'];
    }

    //Reestablece los estilos de los elementos
    restablecerEstilos() {
        this.a11y.resetState();
        this.funcionesActivas = {};
        this.perfilSeleccionado = null;
    }

    applyProfile = (profile: string) => {
        this.restablecerEstilos();
        this.perfilSeleccionado = profile;

        switch (profile) {
            case 'auditivo':
                this.activarLenguajeSenas();
                break;

            case 'ceguera':
                this.ocultarImagenes();
                break;

            case 'daltonismo':
                this.resaltarEnlaces();
                this.cambiarContraste();
                break;

            case 'dislexia':
                this.activarFuenteDislexia();
                this.cambiarEspaciado();
                break;

            case 'vision-baja':
                this.cambiarEspaciado();
                this.aumentarTamanoFuente();
                this.cambiarContraste();
                this.grancursor();
                break;

            case 'cognitivo':
                this.cambiarEspaciado();
                this.aumentarTamanoFuente();
                this.detenerAnimaciones();
                this.activarGuiaLectura();
                break;

            case 'convulsiones':
                this.cambiarContraste();
                break;

            case 'tdah':
                this.activarMascaraLectura();
                break;

            default:
                console.warn('Perfil de accesibilidad desconocido:', profile);
        }
    };

    //Modal de mapa del sitio
    abrirSitemap() {
        this.dialog
            .open(SitemapComponent, {
                width: '35vw',
                height: '65vh',
                panelClass: 'sitemap-dialog',
            })
            .afterClosed()
            .subscribe((id: string) => {
                if (id) this.irDesdeModal(id);
            });
    }

    irDesdeModal(id: string) {
        const element = document.getElementById(id);
        if (element) {
            const header = -130;
            const y = element.getBoundingClientRect().top + window.scrollY + header;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }
}
